import technicalDiagram from '../assets/AquilonBookshelves.png';

function TechnicalContextPage() {
    return (
        <div className="hero-body">
            <div className="container">
                <h1 className="title is-2">Contexte technique</h1>
                <div className="content">
                        <img src={technicalDiagram} alt="Schéma de l'architecture technique d'Aquilon Bookshelves" />
                    
                </div>
            </div>
        </div>
    );
}

export default TechnicalContextPage;
